// Components==============
import Layout from 'components/Layout/Layout';
import React from 'react';
import './Error.module.scss';
// =========================

export default function Error() {
  return (
    <Layout>
      <div styleName="error-screen">
        <div styleName="wrapper">
          <img src="/images/404.svg" alt="404" />
          <h2>Oeps deze pagina bestaat niet</h2>
          <p>
            Er ging helaas iets mis. Navigeer terug naar de startpagina om Groow
            weer te kunnen gebruiken.
          </p>
        </div>
      </div>
    </Layout>
  );
}
